const defaultLocale = 'de';
const locale = process.env.GATSBY_LOCALE;

export function selectLocaleInNestedObject(obj) {
  Object.keys(obj).forEach(key => {
    if (obj[key] && typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
      // Overwrite key with multiple locales with locale
      if(obj[key].hasOwnProperty(locale) || obj[key].hasOwnProperty(defaultLocale)) {
        obj[key] = selectLocaleInNestedObject((obj[key].hasOwnProperty(locale) ? obj[key][locale] : obj[key][defaultLocale]));
      } else {
        try {
          obj[key] = selectLocaleInNestedObject(obj[key])
        } catch(err) {}
      }
    }
  });

  return obj;
}

export function getBlogPostUrl(post) {
  return `/blogs/${post.fields.blog}/${post.fields.slug}`;
}

export function getProductUrl(product) {
  return `/products/${product.handle}`;
}